import { type RPCException, RPC_ERROR_CODES } from '.';

export const RPC_BAD_CREDENTIALS_EXCEPTION_REASON_TYPES = {
  BAD_PASSWORD: 'bad_password',

  /** 이메일주소 오류. */
  USERNAME_NOT_FOUND: 'username_not_found',

  /** 토큰 오류. 서버측 토큰 DB가 날아간 경우 발생가능. */
  BAD_LOGIN_TOKEN: 'bad_login_token',

  /** 로그인 토큰을 사용 시 누군가 이미 토큰을 사용한 경우(토큰 누출 위험). 경고 표시 필요. */
  LOGIN_TOKEN_THEFT: 'login_token_theft',

  /** 페이스북 토큰이 잘못된 경우. 강제로 페이스북 앱 제거 시 발생. 페이스북 강제 로그아웃 후 재로그인 필요. */
  BAD_FACEBOOK_ACCESS_TOKEN: 'bad_facebook_access_token',

  /** 카카오톡 토큰이 잘못된 경우. */
  BAD_KAKAO_ACCESS_TOKEN: 'bad_kakao_access_token',

  /** 로그인 서비스(QQ, 카카오 등)의 토큰이 잘못된 경우. 강제 로그아웃 후 재로그인 필요. */
  BAD_ACCESS_TOKEN: 'bad_access_token',

  /** Issuer 가 구글 (accounts.google.com , https://accounts.google.com)이 아닌 경우. */
  INVALID_GOOGLE_SIGNIN_ISSUER: 'bad_google_signin_issuer',

  /** 알려지지 않은 Google Client ID가 로그인 시도 */
  UNKNOWN_AUDIENCE: 'unknown_audience',

  /** Access token 이 만료된 경우 */
  EXPIRED_TOKEN: 'expired_token',

  /** Access token 이 issue time 이 잘못된 경우 (미래에 생성됨) */
  INVALID_ISSUE_TIME: 'invalid_issue_time',

  /** Access token 에서 얻은 google ID 와 클라이언트에서 전달된 google ID 가 다름 */
  IMPOSTER: 'imposter',

  /** Invalid instagram access_token, client must refresh access_token and notify to server */
  BAD_INSTAGRAM_ACCESS_TOKEN: 'bad_instagram_access_token',

  /** Invalid authorization code, client must  reissue authorization code. */
  BAD_AUTHORIZATION_CODE: 'bad_authorization_code',

  /** 탈퇴 예약 철회 중 로그인 시도 */
  ACCOUNT_DELETION_RESERVATION: 'account_deletion_reservation',
} as const;

export type RPCBadCredentialsExceptionReasonType =
  (typeof RPC_BAD_CREDENTIALS_EXCEPTION_REASON_TYPES)[keyof typeof RPC_BAD_CREDENTIALS_EXCEPTION_REASON_TYPES];

/**
 * 이메일주소/패스워드 쌍이나 로그인 토큰에 해당하는 계정을 찾을 수 없는 경우 발생하는 예외.
 */
export interface RPCBadCredentialsException
  extends RPCException<
    {
      reason: RPCBadCredentialsExceptionReasonType;
    },
    'com.azarlive.api.exception.BadCredentialsException'
  > {
  code: typeof RPC_ERROR_CODES.BAD_CREDENTIALS;
}
